import React from "react";
import OperationalDocumentEditor from "../common/OperationalDocumentEditor";
import { BonConsumForm } from "../bon_consum/Form";

export default function BonTransferEdit() {
  return <OperationalDocumentEditor kind="transfer" FormComponent={BonConsumForm} />;
}
